import { render, staticRenderFns } from "./RoomBottomNav.vue?vue&type=template&id=3a507ede&lang=pug&"
import script from "./RoomBottomNav.vue?vue&type=script&lang=ts&"
export * from "./RoomBottomNav.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RoomBottomNav.vue"
export default component.exports